// Homepage.jsx
import React, { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import LoadingSpinner from '../components/LoadingSpinner';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import Programs from '../components/Programs';
import Difference from '../components/Difference';
import Belong from '../components/Belong';
import NumberAnimation from '../components/numbers/NumberAnimation';
import UpcomingEvents from '../components/UpcomingEvents';
import News from '../components/News';
import SubFooter from '../components/SubFooter';
import Footer from '../components/Footer';
import ImageSlider from '../components/IconImageSlider';
import PlacementPartners from '../components/PlacementImg';
import WhyUs from '../components/WhyUs';
import CampusVideoSection from '../components/CampusArielView';

// Import images
import aicte from '../assets/aicte-logo.png';
import pci from '../assets/PCI.webp';
import UkGov from '../assets/UK_gov.webp';
import UGC from '../assets/UGC.webp';
import Title from '../components/TitleComponent';

const images = [UGC, pci, UkGov, aicte];

const ErrorFallback = ({ error }) => (
  <div className="p-4 text-red-500">
    <h2>Something went wrong:</h2>
    <pre>{error.message}</pre>
  </div>
);

// Define the component as a named function declaration
function Homepage() {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <div className='w-full h-full flex flex-col font-poppins relative'>
      <Title canonicalPath="/" />
      <Title title="Best University in Dehradun, Uttarakhand "/>
        {/* Preload links */}
        {images.map((img, index) => (
          <link 
            key={index} 
            rel="preload" 
            as="image" 
            href={img} 
          />
        ))}
        
        <Suspense fallback={<LoadingSpinner />}>
          <HeroSection />
          <WhyUs />
          <CampusVideoSection />
          <AboutSection />
          <Programs />
          <Difference />
          <Belong />
          <NumberAnimation />
          <UpcomingEvents />
          <ImageSlider images={images} />
          <PlacementPartners />
          <Footer />
        </Suspense>
      </div>
    </ErrorBoundary>
  );
}

// Export the component as default
export default Homepage;